#import "~/graphql/fragments/Video.graphql"

query GetVideoBySlug(
    $slug: String
)  {
    video(slug: $slug) {
        ...Video
    }
}
